import React from "react";
import {CircularProgress as MuiCircularProgress} from "@mui/material";
import {observer} from "mobx-react";
import "./circularProgress.scss";

function CircularProgress() {
    return (
        <div className="circular-progress">
            <MuiCircularProgress/>
        </div>
    );
}

export default observer(CircularProgress);
